import React from "react"
import { useNavigate } from "react-router-dom";
import styles from './Footer.module.scss'
import eventBus from "../../utils/EventBus";
import Login from "../../Components/Login";
import Contact from "../../Components/Contact";
import TermsOfService from "../../Components/TermsOfService";
import { useAuth } from '../../contexts/AuthContext';

export default function Footer() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    function handleTermsOfServiceClick() {
        eventBus.publish('modal',
            {
                title: "Terms of service",
                content: <TermsOfService/>
            })
    }

    function handleLoginClick() {
        eventBus.publish('modal',
            {
                title: "Login",
                content: <Login/>
            })
    }

    function handleAboutClick() {
        eventBus.publish('modal',
            {
                title: "Contact",
                content: <Contact/>
            })
    }

    function handleDashboardClick() {
        navigate('/dashboard');
    }

    function handleLogoutClick() {
        logout();
        navigate('/');
    }

    return (
        <div className={styles.footer}>
            <hr/>
            <div style={{textAlign: 'left', minWidth: '49%', display: 'inlineBlock', padding: '0'}}>
                <button onClick={handleTermsOfServiceClick}>Terms of Service</button>
                <button onClick={handleAboutClick}>Contact</button>
                {user ? (
                    <>
                        <button onClick={handleDashboardClick}>Dashboard</button>
                        <button onClick={handleLogoutClick}>Logout</button>
                    </>
                ) : (
                    <button onClick={handleLoginClick}>Login</button>
                )}
            </div>
            <div style={{
                minWidth: '50%',
                paddingRight: '0',
                display: 'inlineBlock',
                position: 'right',
                textAlign: 'right'
            }}>
                <p>&copy; {new Date().getFullYear()} Julian's Corner. All rights reserved</p>
            </div>
        </div>
    )
}